import {isValid, parseISO, startOfDay} from "date-fns";

interface ICumulativeDeliveryCounts {
    countForSale: number;
    countReady: number;
    countReadyInThreeMonths: number;
    countReadyInSixMonths: number;
    countReadyInOneYear: number;
}

interface IDeliveryDateBuckets {
    ready: number;
    upToThreeMonths: number;
    threeToSixMonths: number;
    upToSixMonths: number;
    sixToTwelveMonths: number;
    aboveOneYear: number;
    inConstruction: number;
}

/**
 * The clamp is a safety net for region stats that are aggregated asynchronously - a snapshot may briefly break the
 * inclusion between buckets. A negative count would be rendered into the description, so the bucket is dropped instead.
 */
const bucketDifference = (widerBucket: number, narrowerBucket: number): number => Math.max(widerBucket - narrowerBucket, 0);

/**
 * `count_ready_in_3m/_6m/_12m` from the API are cumulative - each one counts properties delivered no later than
 * today + N months, so `ready ⊆ ready_in_3m ⊆ ready_in_6m ⊆ ready_in_12m`. Texts need disjoint ranges that add up
 * to the number of properties for sale, hence the differences.
 */
export const getDeliveryDateBuckets = (counts: ICumulativeDeliveryCounts): IDeliveryDateBuckets => ({
    ready: Math.max(counts.countReady, 0),
    upToThreeMonths: bucketDifference(counts.countReadyInThreeMonths, counts.countReady),
    threeToSixMonths: bucketDifference(counts.countReadyInSixMonths, counts.countReadyInThreeMonths),
    upToSixMonths: bucketDifference(counts.countReadyInSixMonths, counts.countReady),
    sixToTwelveMonths: bucketDifference(counts.countReadyInOneYear, counts.countReadyInSixMonths),
    aboveOneYear: bucketDifference(counts.countForSale, counts.countReadyInOneYear),
    inConstruction: bucketDifference(counts.countForSale, counts.countReady)
});

/**
 * `latest_construction_date` may already be in the past - such a date says nothing about a planned delivery,
 * so texts using it are skipped. Returns the date only when it is still upcoming.
 */
export const getUpcomingDeliveryDate = (deliveryDate: string | null): string | null => {
    if (!deliveryDate) {
        return null;
    }

    const parsedDeliveryDate = parseISO(deliveryDate);

    if (!isValid(parsedDeliveryDate) || parsedDeliveryDate < startOfDay(new Date())) {
        return null;
    }

    return deliveryDate;
};
import {isValid, parseISO, startOfDay} from "date-fns";

interface ICumulativeDeliveryCounts {
    countForSale: number;
    countReady: number;
    countReadyInThreeMonths: number;
    countReadyInSixMonths: number;
    countReadyInOneYear: number;
}

interface IDeliveryDateBuckets {
    ready: number;
    upToThreeMonths: number;
    threeToSixMonths: number;
    upToSixMonths: number;
    sixToTwelveMonths: number;
    aboveOneYear: number;
    inConstruction: number;
}

/**
 * The clamp is a safety net for region stats that are aggregated asynchronously - a snapshot may briefly break the
 * inclusion between buckets. A negative count would be rendered into the description, so the bucket is dropped instead.
 */
const bucketDifference = (widerBucket: number, narrowerBucket: number): number => Math.max(widerBucket - narrowerBucket, 0);

/**
 * `count_ready_in_3m/_6m/_12m` from the API are cumulative - each one counts properties delivered no later than
 * today + N months, so `ready ⊆ ready_in_3m ⊆ ready_in_6m ⊆ ready_in_12m`. Texts need disjoint ranges that add up
 * to the number of properties for sale, hence the differences.
 */
export const getDeliveryDateBuckets = (counts: ICumulativeDeliveryCounts): IDeliveryDateBuckets => ({
    ready: Math.max(counts.countReady, 0),
    upToThreeMonths: bucketDifference(counts.countReadyInThreeMonths, counts.countReady),
    threeToSixMonths: bucketDifference(counts.countReadyInSixMonths, counts.countReadyInThreeMonths),
    upToSixMonths: bucketDifference(counts.countReadyInSixMonths, counts.countReady),
    sixToTwelveMonths: bucketDifference(counts.countReadyInOneYear, counts.countReadyInSixMonths),
    aboveOneYear: bucketDifference(counts.countForSale, counts.countReadyInOneYear),
    inConstruction: bucketDifference(counts.countForSale, counts.countReady)
});

/**
 * `latest_construction_date` may already be in the past - such a date says nothing about a planned delivery,
 * so texts using it are skipped. Returns the date only when it is still upcoming.
 */
export const getUpcomingDeliveryDate = (deliveryDate: string | null): string | null => {
    if (!deliveryDate) {
        return null;
    }

    const parsedDeliveryDate = parseISO(deliveryDate);

    if (!isValid(parsedDeliveryDate) || parsedDeliveryDate < startOfDay(new Date())) {
        return null;
    }

    return deliveryDate;
};
